/* eslint-disable @typescript-eslint/no-explicit-any */
import useGetAgents from '@/hooks/useGetAgents';
import { Dispatch, FC, SetStateAction } from 'react';
import EditRecordModal from './EditRecordModal';

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  agent: any;
  columns: string[];
}

const UserFormModal: FC<Props> = ({ agent, isOpen, setIsOpen, columns }) => {
  const { data: agents } = useGetAgents();

  return (
    <EditRecordModal
      record={agent}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      columns={columns}
      selectField={{
        label: 'Agent',
        placeholder: 'Select Agent',
        fieldKey: 'agent',
        items: agents?.map((a) => ({
          label: `${a.firstName} ${a.lastName}`,
          value: a.identifier,
        })),
        defaultValue: agent?.agent || '',
      }}
      successMessage="Successfully Edited User"
    />
  );
};

export default UserFormModal;
